import {
  INDICATOR_LABEL_FONT_SIZE_PX,
  INDICATOR_LABEL_FONT_WEIGHT,
  INDICATOR_LABEL_GAP_PX,
  INDICATOR_LABEL_HEIGHT_PX,
  INDICATOR_LABEL_PADDING_X_PX,
  INDICATOR_LABEL_RADIUS_PX,
} from "../constants";
import { roundedRectPath } from "../text/roundedRect";

const drawLabel = (textLayer, { text, x, y, isAbove, font, background, color }) => {
  const width = textLayer.measure(text, font) + 2 * INDICATOR_LABEL_PADDING_X_PX;
  const top = isAbove ? y - INDICATOR_LABEL_GAP_PX - INDICATOR_LABEL_HEIGHT_PX : y + INDICATOR_LABEL_GAP_PX;
  const rect = { x: x - width / 2, y: top, width, height: INDICATOR_LABEL_HEIGHT_PX };

  roundedRectPath(textLayer.context, rect, INDICATOR_LABEL_RADIUS_PX);
  textLayer.context.fillStyle = background;
  textLayer.context.fill();
  textLayer.drawText(text, x, top + INDICATOR_LABEL_HEIGHT_PX / 2, { font, color, align: "center" });
};

/**
 * Signal labels of the indicators over the price chart (SuperTrend Buy /
 * Sell): definition.labels { key, text, plotKey, isAbove } put a box in
 * the colour of the plot `plotKey` over (isAbove) or under the value of
 * series[key] at every bar where it has one. Hidden with the indicator or
 * with that plot; only labels on the visible bars inside the pane are drawn.
 *
 * @param {object} textLayer
 * @param {object[]} instances - indicators over the price chart (createIndicators.priceIndicators)
 * @param {object} params
 * @param {object} params.timeScale
 * @param {object} params.priceScale
 * @param {{ width: number, height: number }} params.pane
 * @param {{ first: number, last: number }} params.range - visible bars
 * @param {string} params.fontFamily
 * @param {string} params.textColor - CSS colour
 */
export const drawIndicatorLabels = (
  textLayer,
  instances,
  { timeScale, priceScale, pane, range, fontFamily, textColor },
) => {
  const font = `${INDICATOR_LABEL_FONT_WEIGHT} ${INDICATOR_LABEL_FONT_SIZE_PX}px ${fontFamily}`;

  instances.forEach(({ definition, series, styles, isVisible }) => {
    if (!isVisible || !definition.labels) return;

    definition.labels.forEach(({ key, text, plotKey, isAbove }) => {
      const style = styles.plots[plotKey];
      const values = series[key];

      if (!style.isVisible) return;

      for (let index = Math.max(0, range.first); index <= Math.min(range.last, values.length - 1); index += 1) {
        const x = timeScale.indexToX(index);
        const y = Number.isFinite(values[index]) ? priceScale.priceToY(values[index]) : NaN;

        if (y >= 0 && y <= pane.height && x >= 0 && x <= pane.width) {
          drawLabel(textLayer, { text, x, y, isAbove, font, background: style.color, color: textColor });
        }
      }
    });
  });
};
